/* eslint-disable no-undef */
export default class CciTrackingModule {
    constructor () {
      this.eventListeners = {}
      this.app = null
      this.issueData = null
    }
  
    trackEvent (contextKey, actionKey, obj, label, value, extraInfo) {
      if (!this.hasListeners(actionKey)) { return }
  
      let baseData = {'context': contextKey}
      baseData = Object.assign(baseData, {'action': actionKey})

      if (label !== undefined) {
        const labelData = {'label': label}
        baseData = Object.assign(baseData, labelData)
      }
      if (value !== undefined) {
        const valueData = {'value': value}
        baseData = Object.assign(baseData, valueData)
      }
  
      if (extraInfo !== undefined) {
        baseData = Object.assign(baseData, {'extraInfo': extraInfo})
      }

      baseData = Object.assign(baseData, {'orientation': this.app.isSinglePages ? 'Portrait' : 'Landscape'})
  
      // var issueData = Object.assign(baseData, this.getIssueData())
      let issueData = this.getIssueData()
      if (obj !== undefined && obj.kind === 'Page') {
        // We have a page object.

        // get page data
        let pageData = this.getPageData(obj)
        // merge page and issue data
        pageData = Object.assign(issueData, pageData)
        baseData =  Object.assign(baseData, {'attributes': pageData})
      } else if (obj !== undefined && obj.kind === 'Article') {
        // We have an article object.

        // get article data
        const articleData = this.getArticleData(obj)
        // get page data
        const articlePageData = this.getPageData(obj.page)

        // merge article, page and issue data
        let articleMergeData = Object.assign(issueData, articlePageData)
        articleMergeData = Object.assign(articleMergeData, articleData)
        baseData = Object.assign(baseData, {'attributes': articleMergeData})
      } else if (obj !== undefined && obj.kind === 'Ad') {
        // We have an ad object.
        var adData = this.getAdData(obj)
        var adPageData = this.getPageData(obj.page)
        var adMergeData = Object.assign(issueData, adPageData)
        adMergeData = Object.assign(adMergeData, adData)
        // send event for ad
        this.sendEvent(actionKey, adMergeData)
        return  
      } else {
        baseData = Object.assign(baseData, {'attributes': issueData})
      }
  
      this.emitEvent(actionKey, baseData)
    }
  
    // emit event to all listeners
    emitEvent (actionKey, eventData) {
      let listeners = []
      if (this.eventListeners[actionKey] !== undefined) {
        listeners = listeners.concat(this.eventListeners[actionKey])
      }
      if (this.eventListeners['AllActions'] !== undefined) {
        listeners = listeners.concat(this.eventListeners['AllActions'])
      }
      if (listeners) {
        listeners.forEach(callback => callback(eventData));
      }
    }
  
    // check if there are any listeners for the actionKey
    hasListeners (actionKey) {
      return this.eventListeners[actionKey] !== undefined || this.eventListeners['AllActions'] !== undefined
    }
  
    getIssueData () {
      return {
        'publication_name': this.issueData.publicationName,
        'issue_name': this.issueData.issueName,
        'issue_internal_name': this.issueData.issueInternalName,
        'issue_internal_id': this.issueData.issueInternalId,
        'issue_pub_date': this.issueData.pubDateDate,
        'issue_zone': this.issueData.zoneCont,
        'issue_edition': this.issueData.editionCont
      }
    }
  
    getPageData (singlePage) {
      return {
        'page_section_name': singlePage.attributes.SectionName,
        'page_layout_desk': singlePage.attributes.LayoutDeskCont,
        'page_internal_id': singlePage.id,
        'page_number': singlePage.attributes.Page,
        'page_internal_name': singlePage.attributes.Name
      }
    }
  
    getArticleData (article) {
      let byline = ''
      if (article.attributes.Byline !== undefined) {
        byline = article.attributes.Byline
      }
      let onlineUrl = ''
      if (article.attributes.OnlineURL !== undefined) {
        onlineUrl = article.attributes.OnlineURL
      }
      return {
        'article_internal_id': article.id,
        'article_internal_name': article.attributes.Name,
        'article_headline': article.attributes.TeaserText ? article.attributes.TeaserText : article.attributes.Headline,
        'article_byline': byline,
        'article_online_url': onlineUrl,
        'article_image_count': article.children !== undefined ? this.getArticleImageCount(article) : 0,
        'article_html_url': this.app.getEncodedResourceUrl(article.html, article.attributes.LastRev)
      }
    }

    getAdData (ad) {
      return {
        'ad_internal_id': ad.id,
        'ad_internal_name': ad.attributes.Name,
      }
    }  
  
    getArticleImageCount (article) {
      let count = 0
      for (let index = 0; index < article.children.length; index++) {
        const element = article.children[index];
        if (element.kind === 'Photo' || element.kind === 'Graphics') {
          count++
        }
      }
      return count
    }
  }
  /* eslint-enable no-undef */
  